import AuthService from "../../utils/AuthService";

class GameServer {
  notify(gamecode, event, msg, onMsgHandlers) {
    console.log("Initing.. Game:", gamecode, "event:", event);
    const token = AuthService.getAuthToken();
    const ws = new WebSocket(`${AuthService.WSAPI_BASE_URL}?token=${token}`);
    ws.onopen = function open() {
      console.log("connected");
      ws.send(
        JSON.stringify({
          action: event,
          channel: `${gamecode}`,
          version: "v1",
          message: JSON.stringify(msg),
        })
      );
    };
    ws.onclose = function close() {
      console.log("disconnected");
    };

    ws.onmessage = function incoming(data) {
      const msgtype = JSON.parse(data.data).type;
      console.log("msgtype", msgtype);
      if (onMsgHandlers) {
        let msghandler = onMsgHandlers[msgtype];
        if (msghandler) {
          msghandler(JSON.parse(data.data));
        }
      }
    };
  }
}

export default new GameServer();
